import { Link } from 'react-router-dom';
import { Star, ArrowRight } from 'lucide-react';

export const HsmBanner = () => (
  <Link
    to="/high-school-musical"
    data-testid="hsm-banner"
    className="block bg-gradient-to-r from-[#2a0a0c] via-[#4a1013] to-[#2a0a0c] border-y border-[#d4a017]/40 hover:border-[#d4a017]/70 transition-colors group"
  >
    <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-center gap-2 sm:gap-3 text-center flex-wrap">
      <Star className="w-4 h-4 text-[#f5c542] flex-shrink-0" />
      <span className="text-sm sm:text-base font-bold text-white">
        Next summer&apos;s show: <span className="text-[#f5c542]">High School Musical Jr</span>
      </span>
      <span className="hidden sm:inline text-sm text-white/70">— train now and be part of it</span>
      <span className="inline-flex items-center gap-1 text-sm font-bold text-[#f5c542] group-hover:gap-2 transition-all">
        Find out more <ArrowRight className="w-4 h-4" />
      </span>
    </div>
  </Link>
);

export default HsmBanner;
